"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  useSendUserData: () => useSendUserData
});
module.exports = __toCommonJS(src_exports);

// src/useSendUserData.ts
var import_client = require("hono/client");
var import_react_query = require("@tanstack/react-query");
var getClient = () => {
  const baseUrl = process.env.REACT_APP_FORMS_URL;
  if (!baseUrl) {
    throw new Error("REACT_APP_FORMS_URL is not defined");
  }
  return (0, import_client.hc)(baseUrl);
};
var useSendUserData = () => {
  const _a = (0, import_react_query.useMutation)({
    mutationFn: (_0) => __async(void 0, [_0], function* ({
      eventId,
      storeId,
      companyId,
      extraData,
      extraDataLabel,
      email,
      name,
      userId,
      source,
      chatLoginConfig
    }) {
      var _a2, _b;
      const client = getClient();
      const formData = {
        name
      };
      if (email && email !== "" && ((_a2 = chatLoginConfig.email) == null ? void 0 : _a2.visible)) {
        formData.email = email;
      }
      if (extraData && extraData !== "" && extraDataLabel && extraDataLabel !== "" && ((_b = chatLoginConfig.nationalId) == null ? void 0 : _b.visible)) {
        formData[extraDataLabel] = extraData;
      }
      const res = yield client.events[":eventId"].users[":userId"].$put({
        param: { eventId, userId },
        query: { source },
        json: {
          storeId,
          companyId,
          formData
        }
      });
      return yield res.json();
    })
  }), { mutateAsync } = _a, rest = __objRest(_a, ["mutateAsync"]);
  return __spreadValues({ sendUserData: mutateAsync }, rest);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  useSendUserData
});
